import apiClient from './../apiClient'
import propertyClickeds from './property-clickeds'
import bannersApi from './banners'
import bannersTypesApi from './bannersTypes'
import citiesApi from './cities'
import propertiesApi from './properties'
import landingPagesApi from './landingPages'
import institutionalPagesApi from './institutionalPages'
import referencePointsApi from './referencePoints'
import enterprisesApi from './enterprises'
import authApi from './auth'
import propertyClickReport from './reports/propertyClickReport'
import formDatas from './formDatas'
import propertyClickedResume from './propertyClickedResume'
import types from './types'
import buildings from './buildings'
import addressesApi from './addresses'
import assetsApi from './assets'
import AIIntegrations from './integrations/AI'
import EvolutionIntegrations from './integrations/Evolution'
import feedbacksApi from './feedbacks'
import auditApi from './audit'
import featureUsageApi from './featureUsage'
import blogPostsApi from './blogPosts'
import blogCategoriesApi from './blogCategories'
import mediasApi from './medias'

export default function api() {
  const data = { apiClient: apiClient({ prefix: 'api' }) }
  const dataV1 = { apiClient: apiClient({ prefix: 'api/v1' }) }

  return {
    propertyClickeds: propertyClickeds(dataV1),
    service: apiClient({ prefix: 'api' }),
    banners: bannersApi(data),
    bannersTypes: bannersTypesApi(data),
    cities: citiesApi(data),
    properties: propertiesApi(data),
    landingPages: landingPagesApi(data),
    institutionalPages: institutionalPagesApi(data),
    referencePoints: referencePointsApi(data),
    enterprises: enterprisesApi(data),
    auth: authApi(data),
    formDatas: formDatas(dataV1),
    propertyClickedResume: propertyClickedResume(dataV1),
    reports: {
      propertyClick: propertyClickReport(dataV1),
      audit: auditApi(dataV1),
      featureUsage: featureUsageApi(data),
    },
    types: types(data),
    buildings: buildings(data),
    addresses: addressesApi(data),
    assets: assetsApi(data),
    integrations: {
      AI: AIIntegrations(data),
      Evolution: EvolutionIntegrations(data),
    },
    blogPosts: blogPostsApi(data),
    blogCategories: blogCategoriesApi(data),
    medias: mediasApi(data),
    feedbacks: feedbacksApi(data),
  }
}
